import React, { useRef, useEffect, useState } from 'react'
import { MunicipalitySearch } from '../../react-municipality-search/'
import * as settings from '../settings.js'

import './styles.scss'

export const Form = ({ 
  userData,
  data,
  handleDataChange
}: {
  userData: Object,
  data: any,
  handleDataChange: (value: Object) => void
}) => {

  const gender: Array<any> = [];
  for(const [key, value] of Object.entries({'m': 'Männlich', 'w': 'weiblich', '': 'egal'}))
  {
    gender.push(<button className={`ui button party ${userData.sex === key ? 'active' : ''}`}
      key={key}
      onClick={() => handleDataChange({'sex': key})}
    >{value}</button>)
  }

  const parties: Array<any> = [];
  for(const [key, value] of Object.entries(settings.partyCleaned))
  {
    if(['vacant', 'verschiedene'].includes(key)) continue

    parties.push(<button className={`ui button party ${userData.party === key ? 'active' : ''}`}
      key={key}
      onClick={() => handleDataChange({'party': key})}
      style={{color: settings.partyColor[key]}}  
    >{value}</button>)
  }

  return (
    <div className='form'>

      <div className='step municipality-selection'>
        <h2>Meine Zürcher Gemeinde prüfen</h2>
        <h4 className='ui tiny header'>Gemeinde</h4>

        <MunicipalitySearch
          locale='de'
          dedupe={true}
          // municipalityData='2021v2'
          onSelectionHandler={e => handleDataChange({place: e.GDENR})}
        />

        <h4 className='ui tiny header'>Ihr Alter</h4>
        <div className="ui large input">
          <input type="number"
            min = {1}
            max = {100}
            value={userData.age || ''}
            onChange = {(e) => {
              let n:any = e.target.value
              n = !Number.isNaN(n) ? parseInt(n) : null
              n = n > 100 ? 100 : n < 1 ? 1 : n
              handleDataChange({'age': n})
            }}
            placeholder="Alter"
            style={{width: '120px'}}/>
        </div>        


        <h4 className='ui tiny header'>Ihr Geschlecht</h4>
        <div className='formgender'>
          {gender}
        </div>

        <h4 className='ui tiny header'>Ihre Partei</h4>
        <div className="ui buttonsx">{parties}</div>

        {data && 
          <div id='scroller'><span /></div>
        }

      </div>

    </div>
  )
}
